import metaData from "../data/metaData";
import log from "../utils/log";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";

const upload = async (localURL) => {
  let fileName = uuidv4();
  let data = {
    fileName,
  };

  // Fetch the blob from the local URL
  let blob = await fetch(localURL).then((r) => r.blob());

  // Check the file size (blob.size is in bytes)
  const fileSizeMB = blob.size / (1024 * 1024); // Convert bytes to MB
  if (fileSizeMB > 10) {
    log.debug(`File size exceeds the 10MB limit. Current size: ${fileSizeMB.toFixed(2)} MB`);
    throw new Error("File size exceeds limit");
  }

  const formData = new FormData();
  formData.append("file", blob);
  formData.append("data", JSON.stringify(data));

  const config = {
    headers: {
      "Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
    },
  };

  const res = await axios.post(metaData.serverURL + "upload/single", formData, config);
  log.debug(res);
  return fileName;
};

export default upload;
